import React, { useEffect, useRef } from "react";

import { getRole } from "../../../Core/utils/auth";
import { API } from "../../../Services/api-service";
import useSandboxPremium from "../useSandboxPremium";
import { applyStatsToSession } from "../utils/statsSession";
import SandboxPremiumPopups from "./SandboxPremiumPopups";

/**
 * What the old homepage does for every paid student beyond its own UI, for when
 * the new homepage (SPDashboard) is the one on screen instead: the Sandbox
 * premium paywall (payment due, "upgrade now", the payment-return status) and
 * the session writes from /student/dashboard/stats (`sandbox_user_data` with the
 * subscription, and `linkedUser`, without which Evaluation treats the student
 * as a new visitor).
 *
 * Fetches once, the first time it is active.
 * @param {{ isActive: boolean }} props - the new homepage is the one on screen
 */
const PremiumGate = ({ isActive }) => {
  const premium = useSandboxPremium({ isActive });
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (!isActive || hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    const role = getRole();
    API.get("/student/dashboard/stats")
      .then((res) => applyStatsToSession(res, role).forEach(premium.showSubscriptionPopup))
      .catch((err) => {
        if (err?.response?.data?.code === "PAYMENT_REQUIRED") premium.openPaymentRequired();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive]);

  return <SandboxPremiumPopups {...premium.popups} />;
};

export default PremiumGate;
